import api from './index';
import { setToken } from '../utils/authUtils';

const BASE = '/offeredCluster';

export const getOfferedClusters = async () => api.get(BASE, await setToken()).then((res) => res.data);
